import React from 'react';
import { Box } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";

var PopupFooter = function PopupFooter(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(Box, {
    children: children
  });
};

PopupFooter.displayName = 'PopupFooter';
export { PopupFooter };